<app-flow-action-card icon="image" iconColor="text-teal-600" label="Afbeelding">
  <div class="flex gap-2 items-center">
    <app-avatar
      class="block size-8 rounded overflow-hidden relative shrink-0"
      [src]="imageUrl()"
      [alt]="data().value.label"
    >
      <div
        class="text-lg bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center"
      >
        <mat-icon inline>image</mat-icon>
      </div>
    </app-avatar>

    <div class="flex flex-col gap-0.5 min-w-0">
      <span
        class="truncate"
        [matTooltip]="data().value.label"
        [matTooltipPosition]="'after'"
        >{{ data().value.label }}</span
      >
      <span class="text-xs text-gray-500 flex items-center gap-1">
        <mat-icon class="text-base/4! size-4!">timer</mat-icon>
        {{ data().value.duration }} seconden
      </span>
    </div>
  </div>
</app-flow-action-card>
